export default "__VITE_ASSET__Cobc3ncc__"